import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/App.png'


const _withScopeId = n => (_pushScopeId("data-v-6ae74dca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-login" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row app-login__view" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-6 app-login__view__col" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Welcome to VoIP"),
  /*#__PURE__*/_createElementVNode("p", null, " Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. "),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "App"
  })
], -1))
const _hoisted_5 = { class: "col-6 app-login__view__col d-flex align-items-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-center" }, " Login ", -1))
const _hoisted_7 = { class: "mt-5" }
const _hoisted_8 = { class: "mt-3" }
const _hoisted_9 = { class: "mt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppInput = _resolveComponent("AppInput")!
  const _component_AppInputsValidationProvider = _resolveComponent("AppInputsValidationProvider")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("form", {
            autocomplete: "nope",
            class: "w-100",
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _hoisted_6,
            _createVNode(_component_AppInputsValidationProvider, { onChangeErrorState: _ctx.onChangeErrorState }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_AppInput, {
                    id: "user-login",
                    modelValue: _ctx.email,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                    type: "email",
                    label: "Email",
                    "input-type": "material",
                    "validation-type": "email",
                    "prevent-browser-autocomplete": true
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_AppInput, {
                    id: "user-password",
                    modelValue: _ctx.password,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                    type: "password",
                    label: "Password",
                    "input-type": "material",
                    "prevent-browser-autocomplete": true,
                    "validation-type": "password"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _: 1
            }, 8, ["onChangeErrorState"]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_AppButton, {
                type: "secondary",
                size: "lg",
                class: "mx-auto",
                loading: _ctx.loading,
                onClick: _ctx.submitHandler
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Login ")
                ]),
                _: 1
              }, 8, ["loading", "onClick"])
            ])
          ], 32)
        ])
      ])
    ])
  ]))
}